import { FileTextOutlined, SafetyOutlined } from '@ant-design/icons';

const icons = {
  visits: FileTextOutlined,
  operations: SafetyOutlined
};

const statistics = {
  id: 'group-statistics',
  title: 'Статистика',
  type: 'group',
  children: [
    {
      id: 'login-history',
      title: 'Журнал посещений',
      type: 'item',
      url: '/statistics/login-history',
      icon: icons.visits,
      breadcrumbs: false,
      permission: 'stats:login_history:read'
    },
    {
      id: 'operation-log',
      title: 'Журнал операций',
      type: 'item',
      url: '/statistics/operation-log',
      icon: icons.operations,
      breadcrumbs: false,
      permission: 'stats:operation_log:read'
    }
  ]
};

export default statistics;

